module.exports = __webpack_public_path__ + "img/alphard.59990434.png";